export const InvoiceNumberMask = '0999999999';
